import FooterTop from 'gatsby-theme-dettol/src/components/Footer/FooterTop/FooterTop';
import './FooterTopOverride.scss';

export default FooterTop;
